import CategoriesSection from './CategoriesSection';

export default CategoriesSection;
